import PostDeviationSelector from './PostDeviationSelector';

export default PostDeviationSelector;
